import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderDashboard from '../Components/HeaderDashboard';
import { GetApprovalDetails } from '../Services/ApprovalAPI';

const TripQueueDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const referenceNo = queryParams.get("referenceNo");

    const [approvalDetails, setApprovalDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const hasCalled = useRef(false);

    useEffect(() => {
        if (referenceNo) {
            if (hasCalled.current) return;
            hasCalled.current = true;
            fetchApprovalDetails(referenceNo);
        } else {
            console.warn("Missing referenceNo and trackId");
        }
    }, [referenceNo]);

    const fetchApprovalDetails = async (referenceNo) => {
        try {
            setLoading(true);
            setError("");
            const response = await GetApprovalDetails(referenceNo);
            setApprovalDetails(response.approvalDetails);
            console.log("setApprovalDetails", response.approvalDetails)


        } catch (err) {
            setError("Failed to load flight Requested Approval details. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            {loading && (
                <p class="text-center load"><span class="loader"></span></p>
            )}
            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Dashboard</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="/TripQueue" className="text-muted text-hover-primary">Trip Queue</a>
                                </li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>
                                <li class="breadcrumb-item text-gray-900">Trip Queue Details</li>

                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-items-center flex-wrap">
                        <div class="d-flex align-items-center me-n2 me-lg-0">
                            <a class="btn btn-sm btn-primary me-3" href="/TripQueue">
                                <i class="ki-outline ki-left fs-2"></i> Back To Trip Queues
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* {loading && (
                <div class="row mamage_depo">
                    <div class="col-lg-12">
                        <p className=''>Loading Approval Details...</p>
                    </div>
                </div>
            )} */}

            {approvalDetails && approvalDetails.airBookingResponse.length > 0 ? (
                <>
                    <section className='wraper'>
                        <div className='box_shadow mt-16'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h4 className='headings'>Reason For Travel</h4>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Trip ID </div>
                                        <div class="labl_detls">{approvalDetails.requestedApprovals[0].referenceNo}</div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Travel Mode </div>
                                        <div class="labl_detls">Business Travel</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Employee ID </div>
                                        <div class="labl_detls">{approvalDetails.requestedApprovals[0].employeeId}</div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Employee Name </div>
                                        <div class="labl_detls">{approvalDetails.requestedApprovals[0].travellerName}</div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Biling Entity </div>
                                        <div class="labl_detls">{approvalDetails?.corporateDetails?.companyName}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h4 className='headings'>Travel Info</h4>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">From City </div>
                                        <div class="labl_detls">{approvalDetails.airBookingResponse[0].flightDetails[0].departAirportName} ({approvalDetails.airBookingResponse[0].flightDetails[0].departAirportCode})</div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">To City </div>
                                        <div class="labl_detls">{approvalDetails.airBookingResponse[0].flightDetails[0].arrivalAirportName} ({approvalDetails.airBookingResponse[0].flightDetails[0].arrivalAirportCode})</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Date Of Travel </div>
                                        <div class="labl_detls">{
                                            new Date(
                                                approvalDetails.airBookingResponse[0].flightDetails[0].departDateTime
                                            ).toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric"
                                            })
                                        }</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Total Fare </div>
                                        <div class="labl_detls text-danger"><i className='fa fa-inr'></i> {approvalDetails.airBookingResponse[0].fareDetails.totalFare}</div>
                                    </div>
                                </div>
                                <div className='col-md-12'>
                                    <div class="result_repeat mt-3 mb-3">
                                        <div class="row">
                                            <div class="col-md-8 col-lg-8">
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="row">
                                                            <div class="col-md-4 col-lg-4">
                                                                <div class="flight_img">
                                                                    <div>
                                                                        <img alt="AI Express" width="50" src={`/assets/images/Flight_Images/${approvalDetails.airBookingResponse[0].validatingCarrier}.gif`} /></div></div></div><div class="col-md-8 col-lg-8">
                                                                <figure class="flight_sect">
                                                                    <span>{approvalDetails.airBookingResponse[0].flightDetails[0].airLineName} -{approvalDetails.airBookingResponse[0].flightDetails[0].flightNumber}</span>
                                                                    <span class="airlineImage">{approvalDetails.airBookingResponse[0].flightDetails[0].airLineName} </span>
                                                                </figure>
                                                            </div></div></div>
                                                    <div class="col-md-8 col-lg-8 border-left-right">
                                                        <div class="row">
                                                            <div class="col-md-4 col-lg-4">
                                                                <div class="timer">
                                                                    <h4>
                                                                        {
                                                                            (() => {
                                                                                const flight = approvalDetails.airBookingResponse[0].flightDetails[0];
                                                                                const departure = new Date(flight.departDateTime);

                                                                                const hours = departure.getHours().toString().padStart(2, "0");
                                                                                const minutes = departure.getMinutes().toString().padStart(2, "0");

                                                                                return `${hours}:${minutes}`;
                                                                            })()
                                                                        }
                                                                    </h4>
                                                                    <p>{approvalDetails.airBookingResponse[0].flightDetails[0].departAirportCode}</p>
                                                                </div></div>
                                                            <div class="col-md-3 col-lg-3">
                                                                <div class="deruation">
                                                                    <p>
                                                                        {
                                                                            (() => {
                                                                                const flight = approvalDetails.airBookingResponse[0].flightDetails[0];

                                                                                const departure = new Date(flight.departDateTime);
                                                                                const arrival = new Date(flight.arrivalDateTime);

                                                                                const diffMs = arrival - departure;

                                                                                const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                                                                const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                                                                                return `${hours.toString().padStart(2, "0")}:${minutes
                                                                                    .toString()
                                                                                    .padStart(2, "0")}`;
                                                                            })()
                                                                        }
                                                                    </p>
                                                                    <div class="bordr_top"><i class="fa fa-plane"></i></div>
                                                                    <p class="stops">{approvalDetails.airBookingResponse[0].stops} stop</p></div></div>
                                                            <div class="col-md-4 col-lg-4 offset-1">
                                                                <div class="timer">
                                                                    <h4>
                                                                        {
                                                                            (() => {
                                                                                const flight = approvalDetails.airBookingResponse[0].flightDetails[0];
                                                                                const arrivalTime = new Date(flight.arrivalDateTime);

                                                                                const hours = arrivalTime.getHours().toString().padStart(2, "0");
                                                                                const minutes = arrivalTime.getMinutes().toString().padStart(2, "0");

                                                                                return `${hours}:${minutes}`;
                                                                            })()
                                                                        }
                                                                    </h4>
                                                                    <p>{approvalDetails.airBookingResponse[0].flightDetails[0].arrivalAirportCode}</p>
                                                                </div></div></div></div></div></div>
                                            <div class="col-md-4 col-lg-4">
                                                <div class="price_view">
                                                    <div class="row">
                                                        <div class="col-md-12 col-lg-12">
                                                            <div class="flight_char color"><i class="fa fa-inr"></i>{approvalDetails.airBookingResponse[0].fareDetails.totalFare}</div>
                                                            {/* <button class="view_more">View More Fare</button> */}
                                                        </div>

                                                    </div></div></div><div></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {approvalDetails && approvalDetails.airBookingResponse[0] && approvalDetails.airBookingResponse[0].customerInfo && approvalDetails.airBookingResponse[0].customerInfo.passengerDetails.length > 0 && (
                                <>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <h4 className='headings'>Passenger Details</h4>
                                        </div>
                                        {approvalDetails && approvalDetails.airBookingResponse[0] && approvalDetails.airBookingResponse[0].customerInfo && approvalDetails.airBookingResponse[0].customerInfo.passengerDetails.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <div className='col-md-12'>
                                                    <div class="d-flex mb-3">
                                                        <div class="labl">Passenger Name </div>
                                                        <div class="labl_detls">{item?.title} {item?.firstName} {item?.lastName}</div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </>
                            )}
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h4 className='headings'>Approvals</h4>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Approval Level </div>
                                        <div class="labl_detls text-info">Level 1</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Approvar Name </div>
                                        <div class="labl_detls">{approvalDetails.requestedApprovals[0].level1ApproverName} ({approvalDetails.requestedApprovals[0].level1ApproverEmail})</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Requested By </div>
                                        <div class="labl_detls">{approvalDetails.requestedApprovals[0].travellerName} ({approvalDetails.requestedApprovals[0].userId})</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Created On</div>
                                        <div class="labl_detls">
                                            {(() => {
                                                const dateStr = approvalDetails?.requestedApprovals?.[0]?.createdOn;
                                                if (!dateStr) return "";

                                                const [datePart, timePart] = dateStr.split(" ");
                                                if (!datePart || !timePart) return "";

                                                const [day, month, year] = datePart.split("-");
                                                const [hour, minute, second] = timePart.split(":");

                                                const dateObj = new Date(
                                                    Number(year),
                                                    Number(month) - 1,
                                                    Number(day),
                                                    Number(hour),
                                                    Number(minute),
                                                    Number(second)
                                                );

                                                if (isNaN(dateObj.getTime())) return "";

                                                return dateObj
                                                    .toLocaleString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true
                                                    })
                                                    .replace(",", "");
                                            })()}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Status </div>
                                        <div class="labl_detls text-danger">{approvalDetails.requestedApprovals[0].level1ApprovalStatus} </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Approvar Action On</div>
                                        <div class="labl_detls">
                                            {(() => {
                                                const dateStr = approvalDetails?.requestedApprovals?.[0]?.level1ApprovedOn;
                                                if (!dateStr) return "";

                                                const [datePart, timePart] = dateStr.split(" ");
                                                if (!datePart || !timePart) return "";

                                                const [day, month, year] = datePart.split("-");
                                                const [hour, minute, second] = timePart.split(":");

                                                const dateObj = new Date(
                                                    Number(year),
                                                    Number(month) - 1,
                                                    Number(day),
                                                    Number(hour),
                                                    Number(minute),
                                                    Number(second)
                                                );

                                                if (isNaN(dateObj.getTime())) return "";

                                                return dateObj
                                                    .toLocaleString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true
                                                    })
                                                    .replace(",", "");
                                            })()}
                                        </div>
                                    </div>
                                </div>
                                {approvalDetails.requestedApprovals[0].level1ApprovalStatus ==="Rejected" &&(
                                     <div className='col-md-12'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Remark </div>
                                        <div class="labl_detls text-danger">{approvalDetails.requestedApprovals[0].remark} </div>
                                    </div>
                                </div>
                                )}
                            </div>
                        </div>
                    </section>
                </>
            ) : (
                !loading && approvalDetails && (
                    <>
                        <div class="row mamage_depo">
                            <div class="col-lg-12">
                                <h6 className='ruler'>Flight Approval Details</h6>
                            </div>
                            <div class="col-lg-12">
                                <p className=''>No Flight Approval Details Found !!</p>
                            </div>
                        </div>
                    </>
                )
            )}

        </>
    )
};

export default TripQueueDetail;